/* eslint-disable */
import moment from 'moment';

export default {
  methods: {
    //https://momentjs.com/docs/#/displaying/format/
    formatDate: (value, format = '', lang = '') => {
      if (!value) {
        return '-';
      }

      if (!format) {
        format = 'DD.MM.YYYY';
      }

      if (lang) {
        //Options: da/en, locale is already set in main.js
        //If we have some specific translates situation we can use lang to translate date
        moment.locale(lang)
      }

      const shipmentTransform = (withTime = false) => {
        //Specific shipment format with string manipulation
        const year = value.split('-')[0]
        const currentYear = moment().year();
        format = year.toString() === currentYear.toString() ? 'ddd D. MMM' : 'ddd D. MMM YYYY'

        if (withTime) {
          format = `${format} HH:mm`
        }

        return moment(value).format(format).split(' ').map((str) => {
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }).join(' ');
      }

      if (format === 'shipment') {
        return shipmentTransform();
      } else if (format === 'shipment_last_update') {
        return shipmentTransform(true)
      }

      //Check is value valid for transform
      if (moment(value).isValid()) {
        return moment(value).format(format);
      }

      //Return untransformed value
      return value;
    },
    isValidForTransform: (value) => {
      return moment(value).isValid();
    }
  }
}
